import { IconButton, type IconButtonProps } from '@mui/material'
import { Favorite, FavoriteBorder } from '@tunasong/icons'
import { type FC } from 'react'
import type { FavoriteControlProps } from './favorite-props.js'
import { useFavorites } from './favorites.hook.js'

type FavoriteIconProps = FavoriteControlProps<IconButtonProps>

export const FavoriteIcon: FC<FavoriteIconProps> = props => {
  const { onClick, ...restProps } = props

  const { currentFavorite, toggleFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const FavoriteIcon = currentFavorite ? Favorite : FavoriteBorder

  const template = 'template' in restProps ? restProps.template : getFavoriteTemplateFromEntity(restProps.entity)

  return (
    <IconButton
      {...restProps}
      color={currentFavorite ? 'error' : 'inherit'}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        toggleFavorite(template)
        if (onClick) {
          onClick(ev)
        }
      }}
      aria-label={currentFavorite ? 'Remove from favorites' : 'Add to favorites'}
      sx={{ flex: '0 0 auto', ...restProps.sx }}
    >
      <FavoriteIcon />
    </IconButton>
  )
}

export default FavoriteIcon
